import React from "react";
import { Col, Container, Row } from "reactstrap";
import { useTranslation } from "../../hooks/useTranslation";
import "../../styles/services-list.css";

const ServicesList = () => {
  const t = useTranslation();

  const servicesData = [
    {
      id: 1,
      icon: "ri-truck-fill", // Rental equipment service icon
      titleKey: "services.rental.title",
      descKey: "services.rental.desc",
      highlights: [
        "Premium Equipment",
        "Flexible Terms",
        "24/7 Support",
        "Cost-Effective"
      ],
      ctaKey: "services.learnMore"
    },
    {
      id: 2,
      icon: "ri-building-4-fill",
      titleKey: "services.contracting.title",
      descKey: "services.contracting.desc",
      highlights: [
        "Trusted Partner",
        "Quality Assurance",
        "Timely Delivery",
        "Safety First"
      ],
      ctaKey: "services.learnMore"
    }
  ];

  return (
    <section className="services-section">
      <Container>
        <Row className="section-header">
          <Col>
            {/* <h6 className="section-subtitle">{t("services.subtitle")}</h6> */}
            <h2 className="section-title">{t("services.title")}</h2>
          </Col>
        </Row>

        <Row className="g-4 justify-content-center">
          {servicesData.map((item) => (
            <Col lg="6" key={item.id}>
              <ServiceItem item={item} t={t} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

const ServiceItem = ({ item, t }) => (
  <div className="service-card">
    <div className="card-icon">
      <i className={item.icon} />
    </div>

    <h3>{t(item.titleKey)}</h3>

    <p className="card-description">{t(item.descKey)}</p>

    <div className="highlights-grid">
      {item.highlights.map((highlight, index) => (
        <div key={index} className="highlight-item">
          <i className="ri-checkbox-circle-fill" />
          <span>{highlight}</span>
        </div>
      ))}
    </div>

    {/* <button className="service-cta">
      {t(item.ctaKey)} <i className="ri-arrow-right-line" />
    </button> */}
  </div>
);

export default ServicesList;